/**
 * Enum-ийн монгол нэр — вэбийн дэлгэц ба тайлангийн файл (`report-files`)
 * ИЖИЛ үгээр ярина. Өмнө нь `apps/web/src/lib/types.ts`-д л байсан;
 * тайлангийн файл нэмэгдэхэд (2026-10-06) энд шилжив — хоёр хуулбар
 * болбол нэг нь өөрчлөгдөхөд нөгөө нь хоцорно.
 */
/** Ажилтны дүр — вэбийн цэс, AI туслахын prompt. */
export const ROLE_MN = {
    ADMIN: 'Админ',
    DIRECTOR_READONLY: 'Захирал',
    WAREHOUSE: 'Агуулах',
    STORE_MANAGER: 'Салбарын менежер',
    SALESPERSON: 'Худалдагч',
    COLLECTOR: 'Цуглуулагч',
    ACCOUNTANT: 'Нягтлан',
};
/** Гутлын төлөв. */
export const ITEM_STATUS_MN = {
    COLLECTED: 'Цуглуулсан',
    AVAILABLE: 'Бэлэн',
    RESERVED: 'Захиалагдсан',
    SOLD: 'Зарагдсан',
    RETURNED: 'Буцаагдсан',
    DEFECTIVE: 'Гэмтэлтэй',
    WRITTEN_OFF: 'Актлагдсан',
};
/** Буцаалтын шийдэл. */
export const RETURN_DISPOSITION_MN = {
    RESTOCKED: 'Нөөцөд буцсан',
    DEFECTIVE: 'Гэмтэлтэй',
    RETURN_TO_SUPPLIER: 'Нийлүүлэгч рүү',
    WRITTEN_OFF: 'Актлагдсан',
};
/** Буцаалтын төрөл (2026-10-03). */
export const RETURN_TYPE_MN = {
    REFUND: 'Буцаалт',
    EXCHANGE: 'Солилцоо',
};
/** Баталгааны нэхэмжлэлийн шийдвэр. */
export const CLAIM_RESOLUTION_MN = {
    PENDING: 'Хүлээгдэж буй',
    REPAIR: 'Засвар',
    EXCHANGE: 'Солив',
    REFUND: 'Мөнгө буцаав',
    REJECTED: 'Татгалзсан',
};
/** Захиалгын төлөв. */
export const ORDER_STATUS_MN = {
    ACTIVE: 'Идэвхтэй',
    VOIDED: 'Хүчингүй',
};
//# sourceMappingURL=labels.js.map